export const ADD_IMAGE = 'images/ADD_IMAGE';
export const REMOVE_IMAGE = 'images/REMOVE_IMAGE';



// WEBPACK FOOTER //
// ./src/module/redux/modules/images/types.js